<div class="mfunsPlayer-video-wrap">
    <div class="mfunsPlayer-headBar">
        <div class="mfunsPlayer-title-wrap">
            <div class="mfunsPlayer-headBar-back">
                <div class="icon"></div>
            </div>
            <div class="mfunsPlayer-headBar-title">{{video[currentVideo].title}}</div>
        </div>
        <div class="mfunsPlayer-headBar-time"></div>
        <div class="mfunsPlayer-headBar-right">
            <div class="mfunsPlayer-headBar-device-status">
                <div class="mfunsPlayer-headBar-battery">
                    <div class="battery-quantity">
                        <p class="battery-quantity-value"></p>
                    </div>
                </div>
                <div class="mfunsPlayer-headBar-network"></div>
            </div>
            <div class="mfunsPlayer-headBar-set">
                <!-- <i></i> -->
                <div class="icon"></div>
            </div>
        </div>

    </div>

    <!-- 手势操作区域 -->
    <div class="mfunsPlayer-gesture">
        <div class="forbidden"></div>
        <div class="mfunsPlayer-gesture-wrap unlocked">
            <div class="mfunsPlayer-lock-left"></div>
            <div class="mfunsPlayer-lock-right"></div>
            <div class="mfunsPlayer-danmaku-item-tip">
                <div class="mfunsPlayer-danmaku-item-tip-wrap">
                    <div class="mfunsPlayer-danmaku-item-tip-box">
                        <!-- <i class="mfunsPlayer-danmaku-item-tip-praise"></i>
                        <i class="mfunsPlayer-danmaku-item-tip-cancel"></i> -->
                        <div class="mfunsPlayer-danmaku-item-tip-copy">
                            <i></i>
                        </div>
                        <div class="mfunsPlayer-danmaku-item-tip-report">
                            <i></i>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <div class="forbidden"></div>
    </div>

    <!-- 弹幕区域 -->
    <div class="mfunsPlayer-danmaku" {{ if danmaku && danmaku.margin }} style="margin:{{ danmaku.margin }}px 0" {{ /if }}>
        <div class="mfunsPlayer-danmaku-item mfunsPlayer-danmaku-item--demo"></div>
    </div>
    <!-- <div class="mfunsPlayer-danmaku-item-tip-mask">
        

    </div> -->
    <!-- 视频区域 -->
    <div class="mfunsPlayer-video-mask">
        {{ include './video.art' video[currentVideo] }}
    </div>
    <!-- loading -->
    <div class="mfunsPlayer-loading-tip">
        <div class="mfunsPlayer-loading-icon">
            <span>M</span>
            <span>f</span>
            <span>u</span>
            <span>n</span>
            <span>s</span>
        </div>
        <p class="mfunsPlayer-loading-speed"></p>
    </div>

    <div class="mfunsPlayer-set hide">


        <!-- 视频倍速设置 -->
        {{ include './set/speed.art' }}
        <!-- 播放器设置 -->
        {{ include './set/player.art' $data}}
        <!-- 弹幕设置 -->
        {{ include './set/danmaku.art' }}
        <!-- 视频选集 -->
        {{ include './set/episode.art' video}}
        <!-- 视频分辨率 -->
        {{ include './set/resolution.art' video[currentVideo]}}
        <!-- 弹幕编辑框 -->
        {{ include './set/editDanmaku.art' colors}}



    </div>
    <!-- 播放器通知列表 -->
    <div class="mfunsPlayer-notice-list"></div>
    <!-- 播放器时间提示 -->
    <div class="mfunsPlayer-time-tip hidden"></div>
    <!-- 播放器音量提示 -->
    <div class="mfunsPlayer-volume-tip hidden">
        <div class="tip-icon icon-volume"></div>
        <div class="tip-bar">
            <div class="loaded-bar"></div>
        </div>
    </div>
    <!-- 播放器亮度提示 -->
    <div class="mfunsPlayer-brightness-tip hidden">
        <div class="tip-icon"></div>
        <div class="tip-bar">
            <div class="loaded-bar"></div>
        </div>
    </div>
    <!-- 播放器倍速播放提示 -->
    <div class="mfunsPlayer-speed-tip hidden">
        <div class="tip-icon">
            <ul class="icon-wrap">
                <li class="icon-item"></li>
                <li class="icon-item"></li>
                <li class="icon-item"></li>
            </ul>
        </div>
        <div class="tip-text">
            倍速播放中
        </div>
    </div>
    <!-- 全局输入框 -->
    <div class="mfunsPlayer-fullscreen-input ">
        <div class="inner-item">
            <textarea class="mfunsPlayer-fullscreen-input-content" maxlength="50" placeholder="请说明详情，最多50个字符"></textarea>
        </div>
        <div class="inner-item">
            <div class="mfunsPlayer-fullscreen-input-confirm-button">确认</div>
        </div>
    </div>
    <!-- 弹幕tip -->
    <!-- <div class="mfunsPlayer-danmaku-item-tip-mask">
        <div class="mfunsPlayer-danmaku-item-tip">
            <div class="mfunsPlayer-danmaku-item-tip-wrap">
                <div class="mfunsPlayer-danmaku-item-tip-box">
                    <i class="mfunsPlayer-danmaku-item-tip-praise"></i>
                    <i class="mfunsPlayer-danmaku-item-tip-cancel"></i>
                    <i class="mfunsPlayer-danmaku-item-tip-copy"></i>
                    <i class="mfunsPlayer-danmaku-item-tip-report"></i>
                </div>
            </div>
        </div>
    </div> -->
    <!-- 播放器控制栏 -->
    {{ include './controller.art' $data}}


</div>